import React from 'react';
import { URLS } from '_constants';
import { IsAzAccount, VisitEdit } from 'modules';

function EnforcementEdit() {
  const isAzAccount = IsAzAccount();
  const headerTitle = isAzAccount ? 'Edit inspection visit' : 'Edit enforcement visit';
  const sectionTitle = isAzAccount ? 'Inspection information' : 'Enforcement information';
  return <VisitEdit headerTitle={headerTitle} sectionTitle={sectionTitle} submitUrl={URLS.enforcement} />;
}

export default EnforcementEdit;
